import React from 'react';

import AddIcon from '@mui/icons-material/Add';
import { Button, ButtonProps } from '@mui/material';

export const AddListItemButton: React.FC<ButtonProps> = ({
  children,
  sx,
  ...props
}) => {
  return (
    <Button
      color="info"
      type="button"
      startIcon={<AddIcon sx={{ fontSize: '26px !important', mr: -1 }} />}
      sx={{ textTransform: 'none', fontSize: 16, fontWeight: 700, ...sx }}
      {...props}
    >
      {children}
    </Button>
  );
};
